import React, { useEffect, useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import DialogCancelarEnvio from '../../../paquetes/envios/DialogCancelarEnvio';
import DialogConfirmCancelarEnvio from '../../../paquetes/envios/DialogConfirmCancelarEnvio';
import CtaWithRightButtons from '../../../../components/cta/CtaWithRightButtons';
import DialogConfirmCancEnvAssignedUs from '../../../paquetes/envios/DialogConfirmCancEnvAssignedUs';
import DialogRechazarCancelacion from '../../../paquetes/envios/DialogRechazarCancelacion';
import { firestore } from '../../../../../contexts/FirebaseContext';

function SectionCancelarEnvio({ data, dataAdmin }) {
  const [razonState, setRazonState] = useState(null);
  const { state, user_rol } = data;

  console.log(razonState);

  useEffect(() => {
    function getData() {
      firestore
        .collection('mensaje_items')
        .where('itemId', '==', data.object_id)
        .onSnapshot((query) => {
          const dataArr = query.docs.map((item) => ({ id: item.id, ...item.data() }));

          if (dataArr.length > 0) {
            setRazonState(dataArr[0]);
          }
        });
    }

    getData();
  }, [data.object_id]);

  const dialogProp = {
    color: 'primary',
    size: 'large'
  };
  let component;
  let conditionalText;
  if (state === 'PENDIENTE-PAGO') {
    component = (
      <Button variant="contained" {...dialogProp} disabled>
        Solicitar cancelacion
      </Button>
    );
    conditionalText = 'Este envio aun no se puede cancelar pues aun no se ha pagado.';
  }
  if (state === 'PAGADO') {
    component = <DialogCancelarEnvio dialogProp={dialogProp} data={data} dataAdmin={dataAdmin} />;
    conditionalText = 'Solicitar la cancelacion de este envio.';
  }
  if (state === 'PENDIENTE-CANCELACION') {
    component =
      user_rol === 'cajero' ? (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
          <DialogRechazarCancelacion dialogProp={dialogProp} data={data} />
          <DialogConfirmCancEnvAssignedUs dialogProp={dialogProp} data={data} dataAdmin={dataAdmin} />
        </Box>
      ) : (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
          <DialogRechazarCancelacion dialogProp={dialogProp} data={data} />
          <DialogConfirmCancelarEnvio dialogProp={dialogProp} data={data} dataAdmin={dataAdmin} />
        </Box>
      );
    conditionalText = 'Aceptar o rechazar la cancelacion de este envio.';
  }
  if (state === 'CANCELADO') {
    component = (
      <Button variant="contained" {...dialogProp} disabled>
        Solicitar cancelacion
      </Button>
    );
    conditionalText = 'Este envio ya se ha cancelado.';
  }

  return (
    <Box
      sx={{
        width: '100%',
        padding: '20px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '20px'
      }}
    >
      <CtaWithRightButtons
        title="Cancelar envio"
        contentText="Cancele los envios y guias generadas desde aquí."
        conditionalText={conditionalText}
        razontext={razonState?.message}
        btnAction={component}
      />
    </Box>
  );
}

export default SectionCancelarEnvio;
